import { createError, defineNuxtRouteMiddleware } from '#imports'

import { useBuybackEnabled } from '../composables/useBuybackEnabled/useBuybackEnabled'

export default defineNuxtRouteMiddleware(() => {
  const { isBuybackButtonEnabled } = useBuybackEnabled()

  if (!isBuybackButtonEnabled) {
    throw createError({
      statusCode: 404,
      statusMessage: 'Buyback is not enabled for this market',
      fatal: true,
    })
  }
})
